// DevExtreme locale loader for dynamic language switching
// Usage: import and call loadDevExtremeLocale('tr') or 'en', 'de', etc.

export async function loadDevExtremeLocale(lang) {
  // Map language code to DevExtreme locale file
  const localeMap = {
    tr: 'tr',
    en: 'en',
    de: 'de',
    fr: 'fr',
    ru: 'ru',
    ar: 'ar',
  };
  const code = localeMap[lang] || 'en';
  // DevExtreme locale files are usually named like 'dx.messages.tr.js' and must be imported dynamically
  try {
    switch (code) {
      case 'tr':
        await import('devextreme/localization/messages/tr.json');
        break;
      case 'de':
        await import('devextreme/localization/messages/de.json');
        break;
      case 'fr':
        await import('devextreme/localization/messages/fr.json');
        break;
      case 'ru':
        await import('devextreme/localization/messages/ru.json');
        break;
      case 'ar':
        await import('devextreme/localization/messages/ar.json');
        break;
      case 'en':
      default:
        await import('devextreme/localization/messages/en.json');
        break;
    }
  } catch (e) {
    // fallback: do nothing
  }
}
